/**
 * KAN-755: пороги оптовой скидки: строки "от суммы - процент", добавить
 * порог, удалить порог (последняя строка остаётся).
 */
import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { emptyTier, type TierRow } from '@/lib/discountForm';

interface TiersEditorProps {
  id: string;
  value: TierRow[];
  onChange: (value: TierRow[]) => void;
  disabled?: boolean;
  invalid?: boolean;
}

export function TiersEditor({ id, value, onChange, disabled = false, invalid = false }: TiersEditorProps) {
  const rows = value.length > 0 ? value : [emptyTier()];
  const update = (index: number, patch: Partial<TierRow>): void =>
    onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));

  return (
    <div className="space-y-2" id={id} data-testid={`${id}-tiers`}>
      {rows.map((row, index) => (
        <div key={index} className="flex flex-wrap items-center gap-2" data-testid={`${id}-tier-${index}`}>
          <span className="text-sm text-gray-600">от суммы</span>
          <Input
            inputMode="decimal"
            aria-label={`Порог ${index + 1}: от суммы`}
            className="h-9 w-32"
            value={row.minAmount}
            disabled={disabled}
            aria-invalid={invalid || undefined}
            onChange={(e) => update(index, { minAmount: e.target.value })}
          />
          <span className="text-sm text-gray-600">₽, скидка</span>
          <Input
            inputMode="decimal"
            aria-label={`Порог ${index + 1}: процент`}
            className="h-9 w-20"
            value={row.percent}
            disabled={disabled}
            aria-invalid={invalid || undefined}
            onChange={(e) => update(index, { percent: e.target.value })}
          />
          <span className="text-sm text-gray-600">%</span>
          {rows.length > 1 && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              aria-label={`Удалить порог ${index + 1}`}
              disabled={disabled}
              onClick={() => onChange(rows.filter((_, i) => i !== index))}
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => onChange([...rows, emptyTier()])}
      >
        <Plus className="mr-1 h-4 w-4" />
        Добавить порог
      </Button>
    </div>
  );
}
